export default "And here are a couple more.\n"